module.exports = __webpack_public_path__ + "img/couponDoctor_b.596ec5a3.png";